import React from 'react';
import { color, boxShadow } from '../constants';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import Logo from './logo';
import { ReactComponent as MenuIcon } from '../imnages/menu.svg';
import { ReactComponent as GithubIcon } from '../imnages/github-alt.svg';
import { ReactComponent as FacebookIcon } from '../imnages/facebook-f.svg';
import { ReactComponent as InstagramIcon } from '../imnages/instagram.svg';
import { ReactComponent as TwitterIcon } from '../imnages/twitter.svg';

const NavCont = styled.nav`
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media(min-width: 576px){
    //margin-top: 1rem;
  }
`
const MenuButton = styled.a`
  //margin-left: 1rem;
  margin-left: .4rem;
  border: none;
  background: transparent;
  padding: .5rem .7rem;;
  fill: #999;
  transition: 250ms ease;
  border-radius: .5rem;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .2),
              -2px -2px 2px rgba(255, 255, 255, .5);
  &:hover{
    fill: ${color.sec};
  }
  &:active{
    fill: ${color.prim};
    box-shadow: inset 2px 2px 2px rgba(0, 0, 0, .2),
                inset -2px -2px 2px rgba(255, 255, 255, .5);
  }
  @media(min-width: 576px){
    padding: 1rem 1.2rem;
    margin-left: 1rem;
  }
`
const ContactCont = styled.div`
  display: flex;
  align-items: center;
`
const IconButton = styled.a`
  height: 30px;
  width: 30px;
  background: transparent;
  box-shadow: ${boxShadow.outset};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${({ first }) => first ? 0 : '1rem'};
  text-decoration: none !important;
`
export default ()=> {

  return(
    <header>
      <Container>
        <NavCont className="animated fadeInDown delay-1s">
          <Logo />
          <ContactCont>
            <MenuButton target="_blank" href="https://github.com/felixTineo/raos">
              <GithubIcon width="25" height="25" />
            </MenuButton>
            <MenuButton target="_blank" href="https://www.facebook.com/felix.tineo.9">
              <FacebookIcon width="25" height="25" />
            </MenuButton>
            <MenuButton target="_blank" href="https://www.instagram.com/felixrtineo">
              <InstagramIcon width="25" height="25" />
            </MenuButton>
            <MenuButton target="_blank" href="https://www.twitter.com/felixtineo05">
              <TwitterIcon width="25" height="25"/>
            </MenuButton>
          </ContactCont>
        </NavCont>
      </Container>
    </header>
  )
}
